export default "__VITE_ASSET__ee682958__"